import { Container } from 'pixi.js';
import { TweenOptions } from "./TweenOptions";

/**
 */
export class Tween extends createjs.Tween {
  /**
   */
  public group: string | null;

  public static pauseGroups: string[] = [];
  public static enabledGroups: string[] = [];

  /**
   *
   * @param target
   * @param options
   */
  public static get(target: any, options?: TweenOptions): Tween {
    return new Tween(target, options);
  }

  /**
   *
   * @param target
   * @param props
   */
  public static removeTweens(target: any) {
    if (target instanceof Container) {
      Tween.removeContainerTweens(target);
    } else {
      super.removeTweens(target);
    }
  }

  /**
   *
   * @param target
   * @param props
   */
  public static removeContainerTweens(target: any) {
    if (!target) return;
    for (let i = 0; i < target.children.length; i++) {
      const child = target.children[i];
      Tween.removeTweens(child);
    }
    target.scale && super.removeTweens(target.scale);
    target.pivot && super.removeTweens(target.pivot);
    target.skew && super.removeTweens(target.skew);
    target.pivot && super.removeTweens(target.pivot);
    target.position && super.removeTweens(target.position);
    super.removeTweens(target);
  }

  public static hasActiveTweens = function(target) {
    if (target) return !!target.tweenjs_count;
    return !!(Tween as any)._tweenHead;
  };

  /**
   *
   * @param target
   * @param options
   */
  constructor(target: any, options?: TweenOptions) {
    options = options || {};
    super(target, options);
    this.group = options ? options.group : "";
  }
}

(createjs.Tween as any).timeScale = 1;
createjs.Tween.tick = function(delta, paused) {
  delta = delta * (createjs.Tween as any).timeScale;
  var tween = (createjs.Tween as any)._tweenHead;
  while (tween) {
    const p = Tween.pauseGroups.indexOf(tween.group) !== -1;
    var next = tween._next; // in case it completes and wipes its _next property
    if ((paused && !tween.ignoreGlobalPause) || tween._paused) {
      /* paused */
    } else {
      tween.advance(tween.useTicks ? 1 : delta);
    }
    tween = next;
  }
};
